import React, { Component } from 'react';
import AlertMessage from './AlertMessage';
import withWorkflow from './components/withWorkflow';
import { scrollToMessage } from './util/scrollToMessage';
import RequiredFieldDisclaimer from './components/RequiredFieldDisclaimer';
import PostOfficeBoxPrompt from './components/PostOfficeBoxPrompt';

/**
 * Component for the 'Route' step, to provide patient information in order to route the requisition to the patient to
 * fill in any skipped information.
 */
class Route extends Component {
	
	constructor(props) {
		super(props);
        this.setFormValue = this.setFormValue.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.goBack = this.goBack.bind(this);
        this.updateWorkflow = this.updateWorkflow.bind(this);
		this.affirmPoBox = this.affirmPoBox.bind(this);
		this.denyPoBox = this.denyPoBox.bind(this);
        
        let form = {};
        if (this.props.gearOrder) {
            form.dateOfBirth = { value: this.props.gearOrder.patientInfo ? this.props.gearOrder.patientInfo.dateOfBirth : null }
            form.nameLast = { value: this.props.gearOrder.patientInfo ? this.props.gearOrder.patientInfo.nameLast : null }
            form.email = { value: this.props.gearOrder.patientInfo ? this.props.gearOrder.patientInfo.email : null }
            form.shippingMethod = { value: this.props.gearOrder.shippingMethod || (this.props.gearOrder.containsDropShipRequisition ? "FedEx Ground" : null) }
        }
		
		this.state = {
			showError: false,
			errorMessage: "",
            form: form,
			showPoBoxDialog: false,
			poBox: false
		};
	}
	
	componentDidMount() {
		if (this.props.gearOrder.containsDropShipRequisition) {
			this.props.setLoading(true);
			fetch(process.env.REACT_APP_GEAR_REST_URL+'/is-po-box-patient-address', {
				method: 'POST',
				credentials: 'include',
				mode: 'cors',
				timeout:1000,
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(this.props.gearOrder)
			})
			.then(response => {
				if (response.ok) {
					return response.json(); 
				}
			})
			.then(json => {
				if (json === true) {
					this.setState({
						showPoBoxDialog: true
					});
				}
			})
			.catch(e => { 
				this.setState({
					showError:true,
					errorMessage: "The network is currently unavailable. Please call us at 800-522-4762."
				});
			})
			.finally(() => this.props.setLoading(false));
		}
	}
	
	affirmPoBox() {
		let form = Object.assign({}, this.state.form);
		form.shippingMethod.value = "Smart Post";
		this.setState({
			form: form,
			poBox: true
		});
	}
	
	denyPoBox() {
		this.setState({
			poBox: false
		});
	}
	
	goBack(e) {
		if (this.props.doConfirm(e)){
			this.props.updateStep(this.props.gearOrder, 'handoff', 'Back');
		} else {
			e.preventDefault();
		}
	}
    
    setFormValue(e) {
        let form = Object.assign({}, this.state.form);
        form[e.currentTarget.dataset.fieldname].value = e.currentTarget.value;
        
        this.setState({
            form: form
        });
    }
    validate(form) {
        let validatedForm = Object.assign({}, form);
        Object.values(validatedForm).forEach(prop => {
            prop.valid = true;
            prop.message = "";
        });
        
        if (!validatedForm.dateOfBirth.value) {
            validatedForm.dateOfBirth.valid = false;
            validatedForm.dateOfBirth.message = "Please provide a date of birth.";
        }
        if (!validatedForm.nameLast.value) {
            validatedForm.nameLast.valid = false;
            validatedForm.nameLast.message = "Please provide a last name.";
        }
        if (!validatedForm.email.value) {
            validatedForm.email.valid = false;
            validatedForm.email.message = "Please provide an email address.";
        }
        
        if (this.props.gearOrder.containsDropShipRequisition && !validatedForm.shippingMethod.value) { 
            validatedForm.shippingMethod.valid = false;
            validatedForm.shippingMethod.message = "Please select a shipping method.";
        }
        
        return validatedForm;
    }
	
	submitPatientInfo() {
        this.setState({
            form: this.validate(this.state.form)
        }, () => {
            if (Object.values(this.state.form).every(prop => prop.valid)) {
                let order = this.props.gearOrder;
        		
        		order.patientInfo = order.patientInfo || {};
        		order.patientInfo.dateOfBirth = this.state.form.dateOfBirth.value;
        		order.patientInfo.email = this.state.form.email.value;
        		order.patientInfo.nameLast = this.state.form.nameLast.value;
                order.shippingMethod = this.state.form.shippingMethod.value;
        	   
        		// The back-end updateWorkflow call will save/update the patient info before sending a handoff email
        		this.updateWorkflow('handoff', order, 'Next');
            } else {
                scrollToMessage();
            }
        });
	}
    
    updateWorkflow(currentStep, order, navDirection) {
        fetch(process.env.REACT_APP_GEAR_REST_URL+'/updateWorkflow/', {
            method: 'PUT',
            credentials: 'include',
            mode: 'cors',
            timeout:1000,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(order)
        })
        .then(response => { 
			if (response.ok) {
                return response.json(); 
            } else {
                return Promise.reject({response: response});
            }
        })
        .then(json => {
            if (json.id) {
                this.props.setGearOrder(json);
                this.props.updateStep(json, currentStep, navDirection);
            } else if (json.errors) {
                this.setState({
                    showError: true,
                    errorMessage: json.errors[0].field+' '+json.errors[0].defaultMessage
                });
            }
        })
        .catch(error => {
			if (error.response) {
				this.setState({
	                showError:true,
	                errorMessage: "An unexpected error has occurred. Please call us at 800-522-4762."
	            });
			} else {
	            this.setState({
	                showError:true,
	                errorMessage: "The network is currently unavailable. Please call us at 800-522-4762."
	            });
			}
        });
    }
	
	handleSubmit(event) {
		this.submitPatientInfo();
		event.preventDefault();
	}
	
	render() {
		const patientStepsCompleted = this.props.gearOrder.workflow.steps.findIndex(step => step.skipped) === -1;
		const patient = this.props.gearOrder.patientInfo || {};
        let shippingMethods = (this.state.poBox ? ["Smart Post"] : ["FedEx Ground", "Overnight (Sat. Delivery)", "Overnight (Regular)", "Second Day", "Smart Post"]).map((shippingMethod, index) => {
            return <option key={shippingMethod} value={shippingMethod}>{shippingMethod}</option>;
		});
		let shippingAddress = this.props.gearOrder.patientInfo.addresses.find((address) => address.type === 'shipping');
		
		return (
			<div className="row">
				<div className="col-md-12">
					<AlertMessage display={patientStepsCompleted} />
				</div>
				<form onSubmit={this.handleSubmit} autoComplete="off" noValidate className="col-xs-12">
                    <div className="row">
                        <div className="col-md-12">
        					<h2>
        						Patient Information –&nbsp;
        						<small>We need more information about the patient. Please provide the information below, and we'll send the patient an email requesting any missing information.</small>
        					</h2>
                        </div>
                    </div>
                    <div className="row">
    					<div className="col-md-12">
    						<AlertMessage display={this.state.showError === true} type="danger">
    							<strong>{this.state.errorMessage}</strong>
    						</AlertMessage>
    					</div>
                    </div>
                    <div className="row">
    					<div className={"form-group col-md-3 space-top " + (this.state.form.dateOfBirth.valid === false ? "has-error" : "")}>
    						<div>
    							<label className="control-label" htmlFor="patient-dateOfBirth">Patient's Date Of Birth<span className="text-danger">*</span></label>
    							<input className="form-control" name="patientInfo" id="patient-dateOfBirth" type="date" placeholder="yyyy-mm-dd" defaultValue={patient.dateOfBirth} onChange={this.setFormValue} data-fieldname="dateOfBirth"></input>
                                {this.state.form.dateOfBirth.valid === false && <div className="validation-message text-danger">{this.state.form.dateOfBirth.message}</div>}
    						</div>
    					</div>
    					<div className={"form-group col-md-3 space-top " + (this.state.form.nameLast.valid === false ? "has-error" : "")}>
    						<div>
    							<label className="control-label" htmlFor="patient-nameLast">Patient's Last Name<span className="text-danger">*</span></label>
    							<input className="form-control" name="patientInfo" id="patient-nameLast" type="text" defaultValue={patient.nameLast} onChange={this.setFormValue} data-fieldname="nameLast"></input>
                                {this.state.form.nameLast.valid === false && <div className="validation-message text-danger">{this.state.form.nameLast.message}</div>}
    						</div>
    					</div>
    					<div className={"form-group col-md-6 space-top " + (this.state.form.email.valid === false ? "has-error" : "")}>
    						<div>
    							<label className="control-label" htmlFor="patient-email">Patient's Email<span className="text-danger">*</span></label>
    							<input className="form-control" id="patient-email" maxLength="100" type="text" defaultValue={patient.email} onChange={this.setFormValue} data-fieldname="email"></input>
                                {this.state.form.email.valid === false && <div className="validation-message text-danger">{this.state.form.email.message}</div>}
    						</div>
    					</div>
                    </div>
                    <div className="space-top"></div>
                    {this.props.gearOrder.containsDropShipRequisition && 
                        <div className="row">
                            <div className="col-md-12">
                                <div className={"form-group " + (this.state.form.shippingMethod.valid === false ? "has-error" : "")}>
                                    <label className="control-label">Shipping Method<span className="text-danger">*</span></label>
									<select className="form-control" onChange={this.setFormValue} defaultValue={this.state.form.shippingMethod.value} data-fieldname="shippingMethod">
										{shippingMethods}
									</select>
									{this.state.form.shippingMethod.valid === false && <div className="validation-message text-danger">{this.state.form.shippingMethod.message}</div>}
                                </div>
                            </div>
                        </div>
                    }
                    <div className="space-top"></div>
                    <RequiredFieldDisclaimer />
					<div className="space-top"></div>
                    <div className="row">
    					<div className="col-md-12 sticky-bottom">
    						<button className="btn btn-white radius btn-sm margin-clear" type="button" onClick={this.goBack}>
    							<i className="pl-10 fa fa-arrow-circle-left"></i> &nbsp;
    							Back
    						</button>
    						<button className="btn btn-primary radius btn-sm margin-clear pull-right" type="submit">
    							Submit
    							<i className="pl-10 fa fa-arrow-circle-right"></i>
    						</button>
    					</div>
                    </div>
				</form>
				{this.state.showPoBoxDialog && <PostOfficeBoxPrompt address={shippingAddress} affirmPoBox={this.affirmPoBox} denyPoBox={this.denyPoBox} modalHidden={() => this.setState({ showPoBoxDialog: false })} />}
			</div>
		);
	}
}

// wrap the component in the workflow HOC to get access to common workflow logic
export default withWorkflow(Route);
